<template>
  <div
    data-qa="trigger-tenderstatusChanged">
    <sFormItem
      :label="$t('Common.From')"
      prop="valueMutableFrom"
      :rules="rules.StatusesFrom">
      <sSelect
        class="width-100 black-placeholder"
        clearable
        data-qa="trigger-tenderstatusChanged-StatusesFrom"
        :disabled="disabled"
        multiple
        :placeholder="$t('Automation.FromAnyKind')"
        :value.sync="valueMutableFrom">
        <sOption
          v-for="status in statuses"
          :key="`${status.statusCode}-key`"
          :data-qa="`option-${status.statusCode}`"
          :disabled="disabled"
          :label="status.title"
          :value="status.statusCode"/>
      </sSelect>
    </sFormItem>
    <sFormItem
      :label="$t('Common.To')"
      prop="valueMutableTo"
      :rules="rules.StatusesTo">
      <sSelect
        class="width-100 black-placeholder"
        clearable
        data-qa="trigger-tenderstatusChanged-StatusesTo"
        :disabled="disabled"
        multiple
        :placeholder="$t('Automation.ToAnyKind')"
        :value.sync="valueMutableTo">
        <sOption
          v-for="status in statuses"
          :key="`${status.statusCode}-key`"
          :data-qa="`option-${status.statusCode}`"
          :disabled="disabled"
          :label="status.title"
          :value="status.statusCode"/>
      </sSelect>
    </sFormItem>
  </div>
</template>
<script>
import { modalMixin } from 'mixins'

/**
 * Змінено статус тендера
 * 1
 */
export default {
  name: 'tenderstatusChanged',
  mixins: [modalMixin],
  data() {
    //const that = this
    return {
      rules: {
        /*StatusesFrom: {
          trigger: 'change',
          validator(rule, value, callback) {
            if (!that.valueMutableFrom?.length) {
              callback(new Error(that.$t('Validate.Required')))
            }
            callback()
          },
        },
        StatusesTo: {
          trigger: 'change',
          validator(rule, value, callback) {
            if (!that.valueMutableTo?.length) {
              callback(new Error(that.$t('Validate.Required')))
            }
            callback()
          },
        },*/
      },
      //statuses: []
    }
  },
  computed: {
    valueMutableFrom: {
      get() {
        if (!this.value) {
          return []
        }
        try {
          return JSON.parse(this.value)?.StatusesFrom || []
        } catch {
          return []
        }
      },
      set(newValue) {
        const result = {
          StatusesFrom: newValue,
          StatusesTo: this.valueMutableTo
        }
        this.$emit('update:value', JSON.stringify(result))
      }
    },
    valueMutableTo: {
      get() {
        if (!this.value) {
          return []
        }
        try {
          return JSON.parse(this.value)?.StatusesTo || []
        } catch {
          return []
        }
      },
      set(newValue) {
        const result = {
          StatusesFrom: this.valueMutableFrom,
          StatusesTo: newValue
        }
        this.$emit('update:value', JSON.stringify(result))
      }
    },
    statuses() {
      return  this.$store.getters.getTenderAllStatuses
    }
  },
  async mounted() {
    await this.$store.dispatch('setTenderStatuses')
  },
  props: {
    value: {
      type: String,
    },
    disabled: {
      type: Boolean
    }
  },
}
</script>
<style scoped>
.status-color {
  width: 12px;
  height: 12px;
  margin: auto 10px auto 0;
  background: var(--color);
}
</style>
<style>
.black-placeholder input.s-input__inner::placeholder {
  color: var(--text-color) !important;
  opacity: 1;
}
</style>
